/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-bank.reducer';

export const BloodBankDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodBankEntity = useAppSelector(state => state.bloodBank.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodBankDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodBank.detail.title">BloodBank</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodBank.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.bloodBank.name">Name</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.name}</dd>
          <dt>
            <span id="registrationCode">
              <Translate contentKey="tinyMedicRestApp.bloodBank.registrationCode">Registration Code</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.registrationCode}</dd>
          <dt>
            <span id="registrationAuth">
              <Translate contentKey="tinyMedicRestApp.bloodBank.registrationAuth">Registration Auth</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.registrationAuth}</dd>
          <dt>
            <span id="registrationState">
              <Translate contentKey="tinyMedicRestApp.bloodBank.registrationState">Registration State</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.registrationState}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.bloodBank.email">Email</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.email}</dd>
          <dt>
            <span id="returnInstructions">
              <Translate contentKey="tinyMedicRestApp.bloodBank.returnInstructions">Return Instructions</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.returnInstructions}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.bloodBank.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.taxCode}</dd>
          <dt>
            <span id="billPrefix">
              <Translate contentKey="tinyMedicRestApp.bloodBank.billPrefix">Bill Prefix</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.billPrefix}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.bloodBank.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.createdBy}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodBank.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodBank.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodBank.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodBank.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodBank.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodBankEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBank.hospital">Hospital</Translate>
          </dt>
          <dd>{bloodBankEntity.hospital ? bloodBankEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBank.user">User</Translate>
          </dt>
          <dd>{bloodBankEntity.user ? bloodBankEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBank.contactCode">Contact Code</Translate>
          </dt>
          <dd>{bloodBankEntity.contactCode ? bloodBankEntity.contactCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-bank" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-bank/${bloodBankEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodBankDetail;
